<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form">
    <div class="drawer-form-wrapper fidelity-check-wrapper">
      <p class="text s-16 mb-24">
        Please review all tabs, make the necessary corrections, and check
        "Changes Applied" when complete. If desired, add notes. Emails may be
        sent to the reviewer via the "Review Email" tab.
      </p>
      <nz-tabset
        *ngIf="fidelityData"
        [(nzSelectedIndex)]="selectedTabIndex"
        (nzSelectedIndexChange)="onSelectTab($event)">
        <nz-tab nzTitle="Behavior" *ngIf="isTabVisible('Behavior')">
          <app-correction-needed-behavior
            *ngIf="selectedTab === tabIndex[1]"
            [fidelityData]="behvaiorInputData"
            (formValueChange)="formValueChange($event)"
        /></nz-tab>
        <nz-tab nzTitle="Assesment" *ngIf="isTabVisible('Assesment')"
          ><app-correction-needed-assessment
            *ngIf="selectedTab === tabIndex[2]"
            [fidelityData]="behvaiorInputData"
            (formValueChange)="formValueChange($event)"
        /></nz-tab>
        <nz-tab nzTitle="Strategy" *ngIf="isTabVisible('Strategy')">
          <app-correction-needed-strategy
            *ngIf="selectedTab === tabIndex[3]"
            [fidelityData]="behvaiorInputData"
            (formValueChange)="formValueChange($event)" />
        </nz-tab>
        <nz-tab nzTitle="Data" *ngIf="isTabVisible('Data')"
          ><app-correction-needed-data
            *ngIf="selectedTab === tabIndex[4]"
            [fidelityData]="behvaiorInputData"
            (formValueChange)="formValueChange($event)"
        /></nz-tab>
        <nz-tab nzTitle="Review Email">
          <app-correction-needed-review-email
            *ngIf="selectedTab === tabIndex[5]"
            (formValueChange)="handleEmailSend($event)" />
        </nz-tab>
      </nz-tabset>
    </div>
    <div class="drawer-footer">
      <div class="footer-left">
        <button nz-button type="reset" nzType="default" (click)="onCancel()">
          Cancel
        </button>
      </div>
      <div class="footer-right" *ngIf="selectedTab !== tabIndex[5]">
        <button
          nz-button
          type="button"
          nzType="default"
          class="primary-outlined"
          (click)="saveandClose()"
          [disabled]="!isFormValid">
          Save and Close
        </button>
        <button
          nz-button
          type="button"
          nzType="primary"
          (click)="saveFidelityCheck()"
          [disabled]="!isFormValid">
          Save
        </button>
      </div>
      <div class="footer-right" *ngIf="selectedTab === tabIndex[5]">
        <button nz-button type="button" nzType="primary" (click)="sendEmail()">
          Email Admin and Close
        </button>
      </div>
    </div>
  </form>
</nz-spin>
